var isDesktopSm = function () {
    return window.innerWidth >= ICF.Variables.Breakpoints.DesktopSm;
};

module.exports = isDesktopSm;